import Axios from 'axios';
import {HttpClient} from './httpService';
import {getHttpHeaders} from './header.utils';

export const defaultHttpClient: HttpClient = Axios.create();

// From v0.19.0, defaults should be altered this way 👇
defaultHttpClient.defaults.headers = getHttpHeaders();
defaultHttpClient.defaults.xsrfCookieName = undefined;
